var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{class:{live_chat_open:_vm.isLiveChatStarted, video_expand_bar_open: _vm.showExpandBar},attrs:{"id":"kai-qr-bottom-bar-container","navDir":"horizontal"}},[_c('div',{attrs:{"id":"kai-qr-bottom-bar"}}),_c('NbestBottomPanel'),_c('ShortcutPanel',{class:{shortcut_widget:_vm.useWidgetMode}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }